module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Shirt-fadb035fed7bef30c5e19e1a946c0547.svg";